import { CSSProperties, ReactNode } from "react";
import useMyMontepioContext from "../../../../components/Context/useMyMontepioContext";

import styles from "./BackgroundForm.module.css";

type TBackgroundFormProps = { children: ReactNode; style?: CSSProperties };

export const BackgroundForm = ({ children, style }: TBackgroundFormProps) => {
  const { isMobileAuth } = useMyMontepioContext();

  const defaultStyle = isMobileAuth ? undefined : styles.card;
  const contentStyle = isMobileAuth ? undefined : styles.content;

  return (
    <div style={{ ...style }} className={defaultStyle}>
      <div className={contentStyle}>{children}</div>
    </div>
  );
};
